export default __webpack_public_path__ + "static/media/about-back.d57b57b9.png";